// extracted by mini-css-extract-plugin
module.exports = {"main":"Policies_main__1RAit","scrollable":"Policies_scrollable__2wTec"};